export default {
  common: {
    MOP: 'Pide y Retira',
  },
  checkout: {
    checkoutAlert:
      'En las compras por la web, por el momento, sólo se emite boleta electrónica generalizada.',
  },
  alertDialog: {
    mcDeliveryError: {
      body: 'Mientras tanto, puedes hacer un pedido y retirarlo en el restaurante más cercano con @:common.MOP',
    },
  },
}
